import React from "react";

export default function ModamilyOnboardingFooterText({ text }) {
  return (
    <div className="OnboardingFooterTextContainer">
      <p>{text}</p>
    </div>
  );
}
